import { limparCpfCnpj } from "shared/util/functions/formatacoesDeValores/FormatarValores";

const regexCpfOnzeDigitos = /^\d{11}$/;
const mascaraCpf = /^(\d{3})(\d{3})(\d{3})(\d{2})$/;

/**
 * CN numérico (14 dígitos): XX.XXX.XXX/XXXX-XX.
 * CNPJ alfanumérico (14 caracteres válidos): mesma distribuição de blocos da Receita Federal.
 */
export const formatCNPJ = (cnpj: string): string => {
  if (!cnpj || !cnpj.trim()) return cnpj;
  const normalized = limparCpfCnpj(cnpj);
  if (normalized.length !== 14) {
    return cnpj;
  }
  const comMascara = normalized.replace(/^(.{2})(.{3})(.{3})(.{4})(.{2})$/, "$1.$2.$3/$4-$5");
  return comMascara;
};

/** CPF apenas numérico; caso contrário retorna o valor original. */
export const formatarCpfParaExibicao = (cpf: string): string => {
  if (!cpf || !cpf.trim()) return cpf;
  const n = limparCpfCnpj(cpf);
  if (!regexCpfOnzeDigitos.test(n)) {
    return cpf;
  }
  return n.replace(mascaraCpf, "$1.$2.$3-$4");
};

/** Exibe máscara de CPF (11 dígitos) ou CNPJ/CN alfanumérico (14 posições). */
export const formatarCpfOuCnpjEmissorParaExibicao = (valor: string): string => {
  if (!valor?.trim()) {
    return valor ?? "";
  }
  const n = limparCpfCnpj(valor);
  if (regexCpfOnzeDigitos.test(n)) {
    return formatarCpfParaExibicao(valor);
  }
  if (n.length === 14) {
    return formatCNPJ(valor);
  }
  return valor;
};

/** CPF apenas se o núcleo do documento tiver exatamente 11 dígitos decimais. */
export const rotuloCpfOuCnpj = (valor: string | undefined | null): "CPF" | "CNPJ" => {
  const n = limparCpfCnpj(valor);
  return regexCpfOnzeDigitos.test(n) ? "CPF" : "CNPJ";
};
